import { render, staticRenderFns } from "./denominations.vue?vue&type=template&id=0cbe4e0a"
import script from "./denominations.vue?vue&type=script&lang=js"
export * from "./denominations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports